// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__OL1PV","code":"NotFound_code__TGSBU"};